export default __webpack_public_path__ + "static/media/filmmaker-picture.bd3e9056.jpg";